import { Users, Code2, Hammer, Leaf } from "lucide-react";

const ITEMS = [
    {
        icon: Users,
        title: "Community Support",
        body: "Peer-to-peer mentorship from local builders who’ve shipped with partners and live in your city.",
    },
    {
        icon: Code2,
        title: "Hackathons",
        body: "IRL, high-energy build weekends. Teams form, ship demos, and get feedback from real users.",
    },
    {
        icon: Hammer,
        title: "Build Sessions",
        body: "Focused co-working blocks. Show up, ship, leave with momentum. No talk-shop. No slideware.",
    },
    {
        icon: Leaf,
        title: "Environment",
        body: "A calm, designed space to think. Power, Wi-Fi, coffee, and the right kind of peer pressure.",
    },
];

export default function WhatWeDo() {
    return (
        <section
            id="what"
            data-testid="what-we-do-section"
            className="relative py-20 md:py-32"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
                <div className="max-w-3xl mb-12 md:mb-20">
                    <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-5">
                        <span className="h-px w-8 bg-zinc-400" />
                        What you get
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-[-0.03em] text-zinc-950 leading-[0.95]">
                        Four things we do{" "}
                        <span className="italic font-light">absurdly</span> well.
                    </h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 rounded-3xl overflow-hidden border border-black/10">
                    {ITEMS.map(({ icon: Icon, title, body }) => (
                        <div
                            key={title}
                            data-testid={`what-${title.toLowerCase().replace(/\s+/g, "-")}`}
                            className="group bg-white p-8 md:p-10 min-h-[280px] flex flex-col justify-between hover:bg-zinc-950 hover:text-white transition-colors duration-300"
                        >
                            <div className="h-12 w-12 rounded-2xl bg-zinc-100 group-hover:bg-[#E54D2E] group-hover:text-white inline-flex items-center justify-center transition-colors">
                                <Icon className="h-5 w-5" />
                            </div>
                            <div className="mt-12">
                                <h3 className="font-display text-2xl font-bold tracking-tight">
                                    {title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-zinc-600 group-hover:text-white/70 transition-colors">
                                    {body}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
